<script lang="ts" setup>
const { t } = useI18n()

const { confirmation, cancelConfirmation, confirm } = useConfirmation()

const isOpen = computed({
  get: () => !!confirmation.value,
  set: () => cancelConfirmation()
})
</script>

<template>
  <ResponsiveDialog v-model="isOpen" :title="confirmation?.title">
    <p>{{ confirmation?.description }}</p>
    <footer class="flex gap-2 mt-6">
      <UButton
        :label="confirmation?.cancelMessage || t('cancel')"
        color="neutral"
        variant="outline"
        size="lg"
        icon="i-mingcute-close-line"
        @click="cancelConfirmation"
      />
      <UButton
        :label="confirmation?.confirmMessage || t('confirm')"
        color="primary"
        variant="solid"
        size="lg"
        icon="i-mingcute-check-line"
        @click="confirm"
      />
    </footer>
  </ResponsiveDialog>
</template>
